/**
 * SEO Utility for NebenanHilfe.de
 * Dynamically updates document.title and meta descriptions for search engine crawlers and users.
 */

const DEFAULT_TITLE = 'NebenanHilfe.de – Kostenlose Nachbarschaftshilfe, Marktplatz & Quartier-Gemeinschaft';
const DEFAULT_DESCRIPTION = 'Die moderne Plattform für nachbarschaftliche Hilfe in Deutschland. Nachbarn finden, gegenseitig helfen, Dinge leihen & verschenken. 100% kostenlos und sicher auf deutschen Servern.';

export const updatePageSEO = (title, description) => {
  try {
    // 1. Update Title
    document.title = title ? `${title} | NebenanHilfe.de` : DEFAULT_TITLE;

    // 2. Update or create Meta Description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description || DEFAULT_DESCRIPTION);

    // 3. Update OpenGraph Tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title ? `${title} | NebenanHilfe.de` : DEFAULT_TITLE);
    }

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) {
      ogDesc.setAttribute('content', description || DEFAULT_DESCRIPTION);
    }
  } catch {
    // Graceful fallback for non-DOM environments or testing
  }
};

export const SECTION_SEO = {
  hub: {
    title: 'Übersicht & Quartier-Hub',
    description: 'Dein lokaler Quartier-Hub bei NebenanHilfe.de. Finde Nachbarschaftshilfe, aktuelle Gesuche und Angebote in deiner direkten Umgebung.'
  },
  miteinander: {
    title: 'Miteinander – Nachbarschaftshilfe & Gesuche',
    description: 'Gegenseitige Nachbarschaftshilfe im Quartier. Hilfe anbieten oder Unterstützung bei Garten, Besorgungen und Alltag anfragen.'
  },
  marktplatz: {
    title: 'Marktplatz – Dinge leihen & verschenken',
    description: 'Nachhaltig leihen und verschenken in der Nachbarschaft. Werkzeuge, Bücher, Haushaltsgeräte kostenfrei mit Nachbarn teilen.'
  },
  forum: {
    title: 'Quartiers-Forum & Diskussionen',
    description: 'Tausche dich im Quartiersforum mit deinen Nachbarn über lokale Themen, Empfehlungen und Initiativen aus.'
  },
  wissen: {
    title: 'Wissen & Ratgeber für Nachbarschaftshilfe',
    description: 'Tipps, Leitfäden und Best Practices für erfolgreiche Nachbarschaftshilfe und ein starkes Miteinander im Quartier.'
  },
  freunde: {
    title: 'Nachbarn & Kontakte',
    description: 'Vernetze dich mit Nachbarn in deiner Postleitzahl und baue ein vertrauensvolles Hilfsnetzwerk auf.'
  },
  chat: {
    title: 'Nachrichten & Quartier-Chat',
    description: 'Sichere, verschlüsselte Direktnachrichten mit Nachbarn für Hilfsangebote, Leihanfragen und Absprachen.'
  },
  location: {
    title: 'Standort & Quartier-Radius',
    description: 'Stelle deine Postleitzahl und den gewünschten Umkreis für Hilfsangebote und Nachbarschaftskontakte ein.'
  },
  profile: {
    title: 'Mein Profil & 2FA Sicherheit',
    description: 'Verwalte dein Benutzerprofil, Fähigkeiten für Nachbarschaftshilfe und die Zwei-Faktor-Authentifizierung (TOTP).'
  },
  settings: {
    title: 'Einstellungen & Datenschutz',
    description: 'Passe deine Benachrichtigungen, Spracheinstellungen und Privatsphäre bei NebenanHilfe.de an.'
  },
  security: {
    title: 'Sicherheit, Serverstandort & Richtlinien',
    description: '100% Serverstandort Deutschland, zertifizierte ISO 27001 Rechenzentren, Verhaltensregeln und Meldesystem.'
  },
  search: {
    title: 'Suche im Quartier',
    description: 'Durchsuche Nachbarschaftsangebote, Gesuche, Forenbeiträge und Gegenstände in deiner Umgebung.'
  }
};
